<div class="dialog-container">
  <div class="dialog-header">
    <h1>Under Maintenance</h1>
    @if(data.isAdminUser){
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
  <div class="maintenance-info">
    <img src="assets/images/maintenance_notification.png" alt="Maintenance" />
    <p>
      Under Scheduled Maintenance: <strong>AI Advisor</strong> will be unavailable from {{dateTimeText}}.
    </p>
  </div>
  <div class="img-banner">
    <img src="assets/images/maintenance.svg" alt="Maintenance" />
  </div>
</div>